import React from 'react'
import M1AdvisorsManagement from '../../admin/M1AdvisorsManagement'
import V3PageBridgeFrame from '../V3PageBridgeFrame'

export default function V3M1AdvisorsManagementPage() {
  return <V3PageBridgeFrame><M1AdvisorsManagement /></V3PageBridgeFrame>
}

